import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { showModal } from "../statusModal/statusModal";
import { adminBanUser, deleteUserGameId } from "../users/usersSlice";
import { fetchUsersByQueryAPI } from "./userSearchAPI";

const initialState = {
  cache: {},
  results: [],
  status: "idle",
  chatAccessUpdateStatus: "idle",
  error: null,
};

const mergeUpdatedUser = (user, updatedUser) => {
  if (user._id !== updatedUser._id) {
    return user;
  }

  return {
    ...user,
    ...updatedUser,
  };
};

export const fetchUsersByQuery = createAsyncThunk(
  "users/fetchUserByQuery",
  async (arg, { dispatch, rejectWithValue }) => {
    try {
      const query = typeof arg === "string" ? arg : arg?.query || "";
      const kind = typeof arg === "string" ? "user" : arg?.kind || "user";
      const data = await fetchUsersByQueryAPI(query, kind);
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch admins"
      );
    }
  }
);

const userSearchSlice = createSlice({
  name: "userSearch",
  initialState,
  reducers: {
    resetSearchResults: (state) => {
      state.results = [];
    },
    updateResultsFromCache: (state, action) => {
      state.results = action.payload?.data || [];
      state.status = "succeeded";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersByQuery.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchUsersByQuery.fulfilled, (state, action) => {
        const { query, data, kind } = action.payload;
        const cacheKey = `${kind || "user"}:${query}`;
        state.cache[cacheKey] = { data, kind };
        state.results = data;
        state.status = "succeeded";
      })
      .addCase(adminBanUser.fulfilled, (state, action) => {
        state.results = state.results.map((user) =>
          mergeUpdatedUser(user, action.payload)
        );

        Object.keys(state.cache).forEach((cacheKey) => {
          const cachedEntry = state.cache[cacheKey];

          if (!Array.isArray(cachedEntry?.data)) {
            return;
          }

          state.cache[cacheKey] = {
            ...cachedEntry,
            data: cachedEntry.data.map((user) =>
              mergeUpdatedUser(user, action.payload)
            ),
          };
        });
      })
      .addCase(deleteUserGameId.fulfilled, (state, action) => {
        const { userId, gameIdDocId } = action.payload;

        const removeGameId = (user) => {
          if (user._id !== userId || !Array.isArray(user.gameIds)) {
            return user;
          }

          return {
            ...user,
            gameIds: user.gameIds.filter(
              (gameId) => gameId?._id !== gameIdDocId
            ),
          };
        };

        state.results = state.results.map(removeGameId);

        Object.keys(state.cache).forEach((cacheKey) => {
          const cachedEntry = state.cache[cacheKey];

          if (!Array.isArray(cachedEntry?.data)) {
            return;
          }

          state.cache[cacheKey] = {
            ...cachedEntry,
            data: cachedEntry.data.map(removeGameId),
          };
        });
      })
      .addCase(fetchUsersByQuery.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetSearchResults, updateResultsFromCache } =
  userSearchSlice.actions;

export default userSearchSlice.reducer;
